// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Acknowledgements_wrapper__ITqFo","list":"Acknowledgements_list__YKg3l","listItem":"Acknowledgements_listItem__D_4yY"};